// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#0d291c","white":"#fff","reviews":"styles_reviews__2gLkf","container":"styles_container__ATZ98","wrapper":"styles_wrapper__eKpfU","media":"styles_media__s8NBL"};